import { createContext, useContext } from 'react';

import type { AnyItem } from '@site-builder/block-utils';

interface StoreCardContextValue {
  readonly item: AnyItem;
  readonly quantityInCart: number;
  readonly hasLimit: boolean;
  readonly availableAmount: number;
  readonly maxAvailableAmount: number;
  readonly onPurchase?: () => void;
  readonly onAddToCart: () => void;
  readonly onInCartIncrement: () => void;
  readonly onInCartDecrement: () => void;
}

export const StoreCardContext = createContext<StoreCardContextValue | null>(
  null,
);

export const useStoreCard = (): StoreCardContextValue => {
  const context = useContext(StoreCardContext);
  if (!context) {
    throw new Error('useStoreCard must be used within StoreCardWrapper');
  }
  return context;
};
